import useUser from "api/api-hooks/auth/useUser";
import pluralize from "pluralize";
import { Button } from "reactstrap";
import { Tooltip, Whisper } from "rsuite";
import StrUtils from "utils/StrUtils";
import useSelectableReferences from "../ReferencesHooks/useSelectableReferences";

const AssignSelf = ({
  currentModule,
  field,
  selected,
  setSelected,
  oneTap,
  onClose,
  setKeepOpen,
}) => {
  const { user, userLoading } = useUser();
  const { isRecordSelected, handleSelectRecord } = useSelectableReferences({
    field,
    selected,
    setSelected,
    oneTap,
    onClose,
  });

  return (
    <Whisper
      placement="left"
      trigger="hover"
      delayOpen={400}
      onOpen={() => setKeepOpen(true)}
      onExited={() => setKeepOpen(false)}
      speaker={
        <Tooltip>
          <span>
            {isRecordSelected({ id: user?.id })
              ? `Remove me as the ${pluralize(currentModule?.Name, 1)}`
              : `Add me as the ${pluralize(currentModule?.Name, 1)}`}
          </span>
        </Tooltip>
      }
    >
      <Button
        onClick={selectUserAsContact}
        size="sm"
        outline={!isRecordSelected({ id: user?.id })}
        className="mr-2 btn-icon-only"
        disabled={userLoading}
      >
        <i
          className={`mdi ${
            isRecordSelected({ id: user?.id })
              ? "mdi-account-check"
              : "mdi-account-check-outline"
          }`}
        ></i>
      </Button>
    </Whisper>
  );

  function selectUserAsContact() {
    const record = {
      id: user.id,
      FirstName: StrUtils.getFirstName(user.Name),
      LastName: StrUtils.getLastName(user.Name),
      _RecordName: user.Name,
      _ModuleAPIName: "Contacts",
    };

    handleSelectRecord(record);
  }
};

export default AssignSelf;
